import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { Component, inject, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource } from '@angular/material/table';
import { AppTitleService } from '../../services/app-title.service';
import { UnidadOrganizacionalService } from '../../services/unidad-organizacional.service';
import { AuthService } from '../../services/auth.service';
import { ReportViewerComponent } from '../../commons/report-viewer/report-viewer.component';
import { DlgReporteComponent } from '../../commons/dlg-reporte/dlg-reporte.component';
import { FilesService } from '../../shared/files.service';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-reportes',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatCardModule
  ],
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss']
})
export class ReportesComponent implements AfterViewInit {
  form: FormGroup;
  maxDate: Date = new Date();

  appReports = [{
    'key': 'rpListadoMisTramitesRegistradosPeriodo',
    'title': 'Mis trámites registrados por periodo',
    'description': 'Listado de mis trámites registrados por periodo',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pCodigoParticipante', required: true, visible: false }
    ]
  }, {
    'key': 'rptGrafTramiteMes',
    'title': 'Estadístico gráfico trámite mensual',
    'description': 'Gr\u00E1fico estad\u00edstico de tr\u00E1fico registrados organizados por mes',
  }, {
    'key': 'rptListadoTareasParticipantePeriodo',
    'title': 'Listado de tareas pendientes personal',
    'description': 'Listado de documentos pendientes del personal',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
      { id: 'pServidorPublico', required: true, visible: true }
    ]
  },

  {
    key: 'rptListadoDocumento', title: 'Listado de documentos', description: 'Listado de documentos enviados por numeración, con tiempo de atención y departamento/funcionario destinatario',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
    ]
  },
  {
    key: 'rptListadoDeptFuncionario', title: 'Listado por numeración, departamento y funcionario', description: 'Lista documentos filtrados por departamento y/o funcionario en un periodo.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
    ]
  },
  {
    key: 'rptListadoDocumentoDeptFuncionario', title: 'Listado de documentos por departamento y funcionario', description: 'Listado de documentos filtrado por departamento y/o servidor público en un rango de fechas.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: false, visible: true },
      { id: 'pServidorPublico', required: false, visible: true },
    ]
  },
  {
    key: 'rptListadoTareasPendienteDepartamento', title: 'Tareas pendientes por departamento', description: 'Muestra tareas pendientes del departamento seleccionado dentro de un periodo.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
    ]
  },
  {
    key: 'rptEstadisticoDeptFuncionario', title: 'Estadístico de documentos por departamento/funcionario', description: 'Reporte estadístico con conteo y distribución de documentos por departamento y funcionario en un periodo.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
      { id: 'pServidorPublico', required: false, visible: true },
    ]
  },
  {
    key: 'rptEstadisticoDeptFuncionarioTiempo', title: 'Estadístico: tiempo de atención (días)', description: 'Muestra el tiempo de atención (en días) agregado por departamento y funcionario.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
      { id: 'pServidorPublico', required: false, visible: true },
    ]
  },
  {
    key: 'rptTrazabilidadTramite', title: 'Trazabilidad de un documento', description: ' Brinda una descripción del árbol de atención de un documento con sus tiempos y responsables.',
    'params': [
      { id: 'pAnio', required: true, visible: true },
      { id: 'pNumero', required: true, visible: true }
    ]
  },
  {
    key: 'rptRecepcionTramiteAmpliado', title: 'Recepción de trámite ampliado', description: 'Detalle ampliado de recepción de trámite por año y número.',
    'params': [
      { id: 'pAnio', required: true, visible: true },
      { id: 'pNumero', required: true, visible: true }
    ]
  },
  {
    key: 'rptEstadisticoTareasDepartamental', title: 'Estadístico gráfico departamental', description: 'Muestra el conteo de documentos elaborados, enviados o recibidos por estado para el departamento seleccionado dentro de un periodo',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
    ]
  },
  {
    key: 'rptGrafTramiteDocumento', title: 'Estadístico gráfico tipo documento', description: 'Presenta la distribución de trámites por tipo de documento dentro de un rango de fechas',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
    ]
  },
  {
    key: 'rpTiempoAtencionXLS', title: 'Listado trámites tiempo atención', description: 'Muestra el listado de trámites del periodo con departamento, solicitante y días de atención; además permite exportarlo en XLS.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
    ]
  },
  {
    key: 'rptListadoTramitesGeneralPeriodo', title: 'Listado de trámites general por periodo', description: 'Listado general de trámites en un rango de fechas y horas, agrupado por departamento.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pHoraInicio', required: true, visible: true },
      { id: 'pHoraFin', required: true, visible: true },
      { id: 'pTipoDocumento', required: true, visible: true },
      { id: 'pDepartamento', required: true, visible: true },
    ]
  },
  {
    key: 'rpListadoTramitesGeneralPorDocumentoPeriodo', title: 'Listado de trámites por tipo documento', description: 'Presenta los trámites del rango de fechas agrupados por tipo de documento, mostrando asunto, fecha, solicitante y observación.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pTipoDocumento', required: true, visible: true },
    ]
  },
  {
    key: 'rpListadoTramitesTipoPeriodo', title: 'Listado trámites tiempo atención y tipo documento', description: 'Muestra los trámites del rango de fechas filtrados por tipo documental y agrupados por departamento, incluyendo oficio y días de atención.',
    'params': [
      { id: 'pFechaInicio', required: true, visible: true },
      { id: 'pFechaFin', required: true, visible: true },
      { id: 'pTipoDocumento', required: true, visible: true },
    ]
  },
  {
    key: 'rptBuzonesDeptFuncionarios', title: 'Listado de buzones y funcionarios', description: 'Listado de los buzones disponibles y sus funcionarios públicos para el departamento.',
    'params': [
      { id: 'pDepartamento', required: true, visible: true }
    ]
  }
  ];
  departments: Array<any> = [];
  servidores: Array<any> = [];

  displayedColumns: string[] = ['departamento', 'servidor', 'asunto', 'fecha', 'numero'];
  dataSource = new MatTableDataSource<any>([]);
  loading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('departamentoSelect') departamentoSelect!: MatSelect;

  downloading = false;

  constructor(private fb: FormBuilder, public dialog: MatDialog,
    private reporteService: ReportService,
    private unidadService: UnidadOrganizacionalService, private auth: AuthService,
    private filesService: FilesService) {
    this.form = this.fb.group({
      tipo: [this.appReports[0].key],
      departamento: ['-1'],
      servidor: ['-1'],
      desde: [null],
      hasta: [null]
    });
    inject(AppTitleService).setTitle('Reportes');
    this.loadFilters();
    this.watchDepartamentoChanges();
    this.watchTipoChanges();
  }

  private watchTipoChanges() {
    const ctrl = this.form.get('tipo');
    if (!ctrl) return;
    ctrl.valueChanges.subscribe((val: any) => {
      if (!val) return;
      // When selecting the report that lists buzones, load all departamentos and open the select
      if (val === 'rptBuzonesDeptFuncionarios') {
        // Use the public full-tree endpoint for this report (falls back to listDepartamentos)
        this.unidadService.getUoTodosPublic().subscribe(tree => {
          this.departments = this.flattenUoTree(tree);
          setTimeout(() => { try { if (this.departamentoSelect) this.departamentoSelect.open(); } catch (e) { /* ignore */ } }, 150);
        }, () => {
          // if public tree not allowed, fallback to flat list
          this.unidadService.listDepartamentos().subscribe(list => {
            const mapped = (list || []).map((node: any) => ({ id: node.id || node.codigo || node.idUnidad || node.codigoDpto || node.bdepaCodigo, nombre: node.nombre || node.bdepaNombre || node.descripcion || node.label || node.nombreDepartamento }));
            this.departments = [{ id: -1, nombre: 'Todos' }, ...mapped];
            setTimeout(() => { try { if (this.departamentoSelect) this.departamentoSelect.open(); } catch (e) { /* ignore */ } }, 150);
          }, () => {
            this.departments = [{ id: -1, nombre: 'Todos' }];
            setTimeout(() => { try { if (this.departamentoSelect) this.departamentoSelect.open(); } catch (e) { /* ignore */ } }, 150);
          });
        });
      }
    });
  }

  openFilters(templateRef: any) {
    const dialogRef = this.dialog.open(templateRef, {
      width: '720px',
      panelClass: 'reportes-dialog-panel',
      backdropClass: 'reportes-dialog-backdrop'
    });
    dialogRef.afterClosed().subscribe(() => {
      // optional: refresh or validate after close
    });
  }

  openDlgReporte(reportKey?: string) {
    const ref = this.dialog.open(DlgReporteComponent, {
      width: '720px',
      data: this.appReports.find(item => item.key === reportKey),
      panelClass: 'reportes-dialog-panel',
      backdropClass: 'reportes-dialog-backdrop'
    });
    ref.afterClosed().subscribe(() => {
      // optionally handle after close
    });
  }

  searchAndClose() {
    this.search();
    // close any open dialogs
    try { this.dialog.closeAll(); } catch (e) { /* ignore */ }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private loadFilters() {
    // Load departamentos: if current user is dfw_supervisor show all, otherwise load jerarquico
    const td = this.auth.getTokenData();
    const isSupervisor = td && ((td.name && td.name === 'dfw_supervisor') || (td.roles && td.roles.indexOf('dfw_supervisor') !== -1));

    if (isSupervisor) {
      this.unidadService.getAllDepartamentosTree().subscribe(tree => {
        this.departments = this.flattenUoTree(tree);
      }, () => { this.departments = [{ id: -1, nombre: 'Todos' }]; });
    } else {
      this.unidadService.getDepartamentosTree().subscribe(tree => {
        this.departments = this.flattenUoTree(tree);
      }, () => { this.departments = [{ id: -1, nombre: 'Todos' }]; });
    }
  }

  // react to departamento selection changes: load servidores for that departamento
  private watchDepartamentoChanges() {
    const ctrl = this.form.get('departamento');
    if (!ctrl) return;
    ctrl.valueChanges.subscribe((val: any) => {
      if (!val || val === '-1' || val === -1) {
        this.servidores = [{ id: -1, nombre: 'Todos' }];
        return;
      }
      // call unidad service to get destinatarios for department
      this.unidadService.getDestinatariosByDepartamento(val).subscribe(list => {
        const mapped = (list || []).map((u: any) => ({ id: u.id || u.codigoParticipante || u.codigo, nombre: (u.nombres || '') + (u.apellidos ? (' ' + u.apellidos) : '') }));
        this.servidores = [{ id: -1, nombre: 'Todos' }, ...mapped];
      }, () => {
        this.servidores = [{ id: -1, nombre: 'Todos' }];
      });
    });
  }

  private flattenUoTree(tree: any[]): any[] {
    const out: any[] = [];
    const walk = (node: any) => {
      if (!node) return;
      // node may be array or object
      if (Array.isArray(node)) {
        node.forEach(n => walk(n));
        return;
      }
      out.push({ id: node.id || node.codigo || node.idUnidad || node.codigoDpto || node.bdepaCodigo, nombre: node.nombre || node.bdepaNombre || node.descripcion || node.label || node.nombreDepartamento });
      if (node.uos && node.uos.length) node.uos.forEach((c: any) => walk(c));
      if (node.children && node.children.length) node.children.forEach((c: any) => walk(c));
    };
    walk(tree);
    // prepend 'Todos'
    out.unshift({ id: -1, nombre: 'Todos' });
    return out;
  }

  search() {
    this.dataSource.data = [];
    this.loading = false;
  }

  generar(tipo: string) {
    const params: any = this.form.value;
    this.downloading = true;
    // Convert dates to desired string format if present
    if (params.desde instanceof Date) {
      params.desde = this.formatDateParam(params.desde);
    }
    if (params.hasta instanceof Date) {
      params.hasta = this.formatDateParam(params.hasta);
    }
    // Use backend /rpt/{nr} endpoint
    let url = `/rpt/${encodeURIComponent(tipo)}`;
    const qp: string[] = [];
    qp.push('tipoReporte=pdf');
    if (params.desde) qp.push(`desde=${encodeURIComponent(params.desde)}`);
    if (params.hasta) qp.push(`hasta=${encodeURIComponent(params.hasta)}`);
    // include selected servidor info when available
    const servidorSel = params.servidor;
    let servidorNombre = '';
    const tdAuth = this.auth.getTokenData();
    // rptGrafTramiteMes siempre usa el usuario autenticado
    if (tipo === 'rptGrafTramiteMes') {
      if (tdAuth && tdAuth.name) {
        servidorNombre = tdAuth.name;
        qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
        qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
        if (tdAuth.id) qp.push(`pCodigoParticipante=${encodeURIComponent(tdAuth.id)}`);
      }
    } else {
      if (servidorSel !== undefined && servidorSel !== null && servidorSel != -1) {
        const s = this.servidores.find((it: any) => String(it.id) === String(servidorSel));
        servidorNombre = s ? (s.nombre || s.nombreCompleto || '') : '';
        if (servidorNombre) {
          qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
          qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
          // also pass codigo participante if servidor id seems like participante code
          qp.push(`pCodigoParticipante=${encodeURIComponent(servidorSel)}`);
        }
      }
      // if no servidor selected, fallback to current user name
      if (!servidorNombre) {
        if (tdAuth && tdAuth.name) {
          servidorNombre = tdAuth.name;
          qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
          qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
          if (tdAuth.id) qp.push(`pCodigoParticipante=${encodeURIComponent(tdAuth.id)}`);
        }
      }
    }
    // For reports that require current user as participante (mis trámites), set pCodigoParticipante from token
    if (tipo === 'rpListadoMisTramitesRegistradosPeriodo') {
      const td = this.auth.getTokenData();
      if (td && td.id) qp.push(`pCodigoParticipante=${encodeURIComponent(td.id)}`);
    }
    // If report expects department name, include it (recursivo)
    if (tipo === 'rptBuzonesDeptFuncionarios') {
      const deptId = params.departamento;
      if (deptId !== undefined && deptId !== null && deptId != -1) {
        const d = this.departments.find((it: any) => String(it.id) === String(deptId));
        const deptName = d ? (d.nombre || d.descripcion || d.nombreDepartamento || '') : '';
        if (deptName) qp.push(`pDepartamentoNombre=${encodeURIComponent(deptName)}`);
      }
    }
    url += '?' + qp.join('&');

    console.log('[Reportes] generar: abrir dialogo para', tipo, 'url=', url);
    const vRef: any = this.dialog.open(DlgReporteComponent, {
      width: '90%',
      data: { title: tipo, key: tipo },
      panelClass: 'reportes-dialog-panel',
      backdropClass: 'reportes-dialog-backdrop'
    });
    try {
      if (vRef && vRef.componentInstance && vRef.componentInstance.openReportBlob) {
        console.log('[Reportes] invoking openReportBlob on dialog component');
        vRef.componentInstance.openReportBlob(url);
        console.log('[Reportes] openReportBlob invoked');
      } else {
        console.warn('[Reportes] dialog reference or openReportBlob not available, falling back');
      }
    } catch (e) {
      console.error('[Reportes] error calling openReportBlob, fallback to download', e);
      // fallback: download/open directly
      this.reporteService.getBlob(url).subscribe(blob => {
        console.log('[Reportes] fallback blob received, opening via FilesService');
        this.filesService.openFileFromOctectStream({ blob: blob, filename: `${tipo}.pdf` }, false);
      }, err => console.error('[Reportes] fallback download error', err));
    } finally {
      this.downloading = false;
    }
  }

  generarEnPestana(tipo: string) {
    const params: any = this.form.value;
    // Convert dates to desired string format if present
    if (params.desde instanceof Date) {
      params.desde = this.formatDateParam(params.desde);
    }
    if (params.hasta instanceof Date) {
      params.hasta = this.formatDateParam(params.hasta);
    }
    let url = `/rpt/${encodeURIComponent(tipo)}`;
    const qp: string[] = [];
    qp.push('tipoReporte=pdf');
    if (params.desde) qp.push(`desde=${encodeURIComponent(params.desde)}`);
    if (params.hasta) qp.push(`hasta=${encodeURIComponent(params.hasta)}`);
    const servidorSel = params.servidor;
    let servidorNombre = '';
    const tdAuth = this.auth.getTokenData();
    if (tipo === 'rptGrafTramiteMes') {
      if (tdAuth && tdAuth.name) {
        servidorNombre = tdAuth.name;
        qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
        qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
        if (tdAuth.id) qp.push(`pCodigoParticipante=${encodeURIComponent(tdAuth.id)}`);
      }
    } else {
      if (servidorSel !== undefined && servidorSel !== null && servidorSel != -1) {
        const s = this.servidores.find((it: any) => String(it.id) === String(servidorSel));
        servidorNombre = s ? (s.nombre || s.nombreCompleto || '') : '';
        if (servidorNombre) {
          qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
          qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
          qp.push(`pCodigoParticipante=${encodeURIComponent(servidorSel)}`);
        }
      }
      if (!servidorNombre) {
        if (tdAuth && tdAuth.name) {
          servidorNombre = tdAuth.name;
          qp.push(`pServidor=${encodeURIComponent(servidorNombre)}`);
          qp.push(`pServidorPublico=${encodeURIComponent(servidorNombre)}`);
          if (tdAuth.id) qp.push(`pCodigoParticipante=${encodeURIComponent(tdAuth.id)}`);
        }
      }
    }
    if (tipo === 'rpListadoMisTramitesRegistradosPeriodo') {
      const td = this.auth.getTokenData();
      if (td && td.id) qp.push(`pCodigoParticipante=${encodeURIComponent(td.id)}`);
    }
    // If report expects department name, include it (recursivo)
    if (tipo === 'rptBuzonesDeptFuncionarios') {
      const deptId = params.departamento;
      if (deptId !== undefined && deptId !== null && deptId != -1) {
        const d = this.departments.find((it: any) => String(it.id) === String(deptId));
        const deptName = d ? (d.nombre || d.descripcion || d.nombreDepartamento || '') : '';
        if (deptName) qp.push(`pDepartamentoNombre=${encodeURIComponent(deptName)}`);
      }
    }
    url += '?' + qp.join('&');
    // Open in new tab
    try {
      window.open(url, '_blank');
    } catch (e) {
      console.error('[Reportes] error abriendo en nueva pestaña', e);
    }
  }

  private pad(n: number) { return n < 10 ? '0' + n : n; }
  private formatDateParam(d: Date) {
    // format dd-MM-yyyy to match backend parse in JasperReporte
    return `${this.pad(d.getDate())}-${this.pad(d.getMonth() + 1)}-${d.getFullYear()}`;
  }
}
